<template>
    <div> 
        <!-- USB设置 -->
        <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t("message.menu.OtherSettings") }} </span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">USB ADB:</span>
        <el-select size="medium" v-model="u.c">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
        </el-select>
      </el-col>
      <!-- <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.otherSettingsMsg.USBExternalStorage") }}:</span>
        <el-select size="medium" v-model="u.b">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
        </el-select>
      </el-col> -->
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.otherSettingsMsg.PCUSB") }}:</span>
        <el-select size="medium" v-model="u.d">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t('messageAdd.deact.024') }}</span>
            <el-select size="medium" v-model="u.uf">
              <el-option
              :label="$t('messageAdd.deact.033')"
              :value="0"
              ></el-option>
              <el-option
                :label="$t('messageAdd.deact.034')"
                :value="1"
              ></el-option>
              <el-option
              :label="$t('messageAdd.deact.035')"
              :value="2"
              ></el-option>
              <el-option
                :label="$t('messageAdd.deact.036')"
                :value="3"
              ></el-option>
              <el-option
                :label="$t('messageAdd.deact.037')"
                :value="4"
              ></el-option>
            </el-select>
          </el-col>
    </el-row>
    </div>
</template>
<script>
export default {
  name: "DisplaySettings",
  props:{
    USBSet:{
      type:Object
    }
  },
  data() {
    return {
     
    };
  },
  computed:{
      u(){
      return this.USBSet
      }
    },
  watch:{
   // 监听 u 的变化，并通知父组件
   u: {
      handler(newVal) {
        this.$emit('update:USBSet', newVal);
        this.$emit('update:config-USBSet', newVal);
      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {},
}
</script>
